<div class="text-holder"><div class="text-title"> <slot name="title"></slot></div><div class="text-subtitle"> <slot name="subtitle"></slot></div></div>